import CompletedActivationsContainer from "./CompletedActivationsContainer";
import IncompleteActivationsContainer from "./IncompleteActivationsContainer";
import PendingActivationsContainer from "./PendingActivationsContainer";

import "./style.scss";

type ActivationsContainerProps = {
  activeFilter?: string;
  timeFilter?: string;
};

const ActivationsContainer = ({
  activeFilter = "pending-activations",
  timeFilter = "all",
}: ActivationsContainerProps) => {
  return (
    <div className="activation-container">
      <div className="activation-metrics-content">
        {activeFilter === "pending-activations" && (
          <PendingActivationsContainer timeFilter={timeFilter} />
        )}
        {activeFilter === "completed-activations" && (
          <CompletedActivationsContainer timeFilter={timeFilter} />
        )}
        {activeFilter === "incomplete-activations" && (
          <IncompleteActivationsContainer timeFilter={timeFilter} />
        )}
      </div>
    </div>
  );
};

export default ActivationsContainer;
